import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FacebookSvgrepoCom1Icon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M13.1146 6.49971C13.1146 6.71508 13.1146 7.41703 13.1146 8.41429H16.5434L16.1717 11.4708H13.1146C13.1146 16.1845 13.1146 22.5012 13.1146 22.5012H9.05696C9.05696 22.5012 9.05696 16.2681 9.05696 11.4708H6.94263V8.41429H9.05696C9.05696 7.20216 9.05696 6.34024 9.05696 6.10025C9.05696 4.95684 8.97081 4.41431 9.45666 3.52827C9.94276 2.64226 11.3139 1.47114 13.6853 1.49934C16.0574 1.52856 17.0572 1.75675 17.0572 1.75675L16.5434 5.01425C16.5434 5.01425 15.0287 4.61431 14.2853 4.75684C13.5428 4.89942 13.1146 5.35679 13.1146 6.49971Z"
				fill="currentColor"
			/>
		</svg>
	);
}

FacebookSvgrepoCom1Icon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FacebookSvgrepoCom1Icon;
